<template>
  <v-container fill-height fluid grid-list-md class="custom--container">
    <!-- REMOVED: (for identical tiles) cols="12" sm="3" md="3" -->
    <v-row align="stretch" class="align-content-center fill-height">
      <template v-for="proj in projects">
        <v-col :key="proj.projTitle" cols="6" sm="4" lg="2">
          <v-responsive :aspect-ratio="2">
            <project-tile data-aos="zoom-in" v-bind:proj="proj" />
          </v-responsive>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import ProjectTile from "./ProjectTile.vue";
// import Carousel from './Carousel.vue';
export default {
  name: "Projects",
  components: { ProjectTile },
  props: ["projects"],
};
</script>
